import { Budget } from "../types/budget/budget";
import { ServiceData, ServiceValues } from "../types/budget/service-item";

/** Parts of `ServiceValues` that are not inputs to `calculateServiceTotals`. */
function serviceValuesForCalcComparison(sv: ServiceValues) {
  if (!sv) {
    return {};
  }
  const {
    descriptions,
    observation,
    serviceApplication,
    inputDate,
    outDate,
    serviceType,
    ...rest
  } = sv;
  return rest;
}

function serviceCalcInputSnapshot(service: ServiceData) {
  if (!service) {
    return {};
  }
  return {
    type: service.type,
    calcOption: service.calcOption,
    supplierId: service.supplierId,
    versions: service.versions,
    budgetValues: service.budgetValues ? serviceValuesForCalcComparison(service.budgetValues) : {},
    closingValues: service.closingValues ? serviceValuesForCalcComparison(service.closingValues) : {},
    negotiationValue: (service.negotiationValue ?? []).map(
      serviceValuesForCalcComparison,
    ),
  };
}

/**
 * When true, `UPDATE_SERVICE` only changed text/metadata fields; running
 * `updateCalcValues` over the whole budget would produce the same numbers.
 */
export function shouldSkipBudgetRecalcForMetadataOnlyServiceUpdate(
  prevState: Budget,
  nextService: ServiceData,
): boolean {
  const prev = prevState.budgetServices?.find((s) => s._id === nextService._id);
  if (!prev) return false;
  return (
    JSON.stringify(serviceCalcInputSnapshot(prev)) ===
    JSON.stringify(serviceCalcInputSnapshot(nextService))
  );
}
